import { render } from "./Past.vue?vue&type=template&id=33e64b8b&scoped=true"
import script from "./Past.vue?vue&type=script&lang=js"
export * from "./Past.vue?vue&type=script&lang=js"

import "./Past.vue?vue&type=style&index=0&id=33e64b8b&scoped=true&lang=css"

import exportComponent from "/Users/Learning/Resource/workspace/vscode/HTML/jiang/anniversary/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e64b8b"]])

export default __exports__